export default __webpack_public_path__ + "images/576cc224ca066f6992cc939299e036c3-cycle-count.svg";